import { authHeader } from "../helpers/authHeader";

export const apiService = {
  apiPostForm,
  apiDelete,
  apiGet,
  apiPostJson,
  apiPut,
};

function apiPostJson(url, formData, contentType = 'application/json') {
  const headers = {
    ...authHeader(),
    'Content-Type': contentType,
  };

  const body = contentType === 'application/x-www-form-urlencoded'
    ? formData
    : JSON.stringify(formData);

  const requestOptions = {
    method: 'POST',
    headers,
    body,
  };

  return fetch(url, requestOptions)
    .then(res => {
      if (res.status !== 200 && res.status !== 201) {
        const error = new Error('Request failed');
        error.status = res.status;
        error.url = res.url;
        throw error;
      } else {
        return res.json()
      }
    }
    )
    .then(result => {
      return result;
    });
}




function apiPostForm(url, formData) {

  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: formData
  };

  return fetch(url, requestOptions)
    .then(res => {
      if (res.status !== 200 && res.status !== 201) {
        const error = new Error('Request failed');
        error.status = res.status;
        error.url = res.url;
        throw error;
      } else {
        return res.json()
      }
    }
    )
    .then(result => {
      return result;
    });
}

function apiDelete(url) {

  const requestOptions = {
    method: 'DELETE',
    headers: authHeader(),
  };

  return fetch(url, requestOptions)
    .then(res => {
      if (res.status !== 200 && res.status !== 201) {
        const error = new Error('Request failed');
        error.status = res.status;
        error.url = res.url;
        throw error;
      } else {
        return res.json()
      }
    }
    )
    .then(result => {
      return result;
    });
}

function apiGet(url) {

  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(url, requestOptions)
    .then(res => {
      if (res.status !== 200 && res.status !== 201) {
        const error = new Error('Request failed');
        error.status = res.status;
        error.url = res.url;
        throw error;
      } else {
        return res.json()
      }
    }
    )
    .then(result => {
      return result;
    });
}

function apiPut(url, formData, contentType = 'application/json') {
  const headers = {
    ...authHeader(),
    'Content-Type': contentType,
  };

  const body = contentType === 'application/x-www-form-urlencoded'
    ? formData
    : JSON.stringify(formData);

  const requestOptions = {
    method: 'PUT',
    headers,
    body,
  };

  return fetch(url, requestOptions)
    .then(res => {
      if (res.status !== 200 && res.status !== 201) {
        const error = new Error('Request failed');
        error.status = res.status;
        error.url = res.url;
        throw error;
      } else {
        return res.json()
      }
    }
    )
    .then(result => {
      return result;
    });
}
